/*
 * Datos de testimonios.
 * Cada testimonio almacena un modelId que se resuelve en runtime
 * contra los modelos de la galería (API/DynamoDB o fallback estático).
 */

export const TESTIMONIALS = [
  {
    id: 1,
    modelId: 4,
    tag: 'Platinum Model',
    preview: 'Yo quiero viajar, comprar mi carro...',
    experience:
      'Desde que entré a TM Studio mi vida cambió por completo. Logré comprar mi primer carro y viajar a lugares que antes solo soñaba. No solo por los ingresos, sino por el apoyo y el ambiente profesional que se respira. Es el mejor estudio de Cali sin duda.',
  },
  {
    id: 2,
    modelId: 9,
    tag: 'Lifestyle Pro',
    preview: '¿Cómo es ser modelo Lifestyle?',
    experience:
      'Ser modelo Lifestyle en TM Studio me permitió equilibrar mi carrera con mi vida personal. El equipo entiende nuestras necesidades y nos da la flexibilidad para crecer sin sacrificar lo que amamos. Recomiendo TM a cualquier chica que quiera empezar en el mundo del modeling.',
  },
  {
    id: 3,
    modelId: 14,
    tag: 'Studio Elite',
    preview: 'Mi crecimiento en TM Studio',
    experience:
      'Llevo más de dos años aquí y el crecimiento ha sido increíble. TM Studio no es solo un trabajo, es una familia que te impulsa a dar lo mejor. Los pagos son puntuales, el ambiente es seguro y el equipo siempre está para apoyarte.',
  },
  {
    id: 4,
    modelId: 26,
    tag: 'Rising Star',
    preview: 'Mi segundo carro',
    experience:
      'Con mis ingresos en TM Studio pude comprar mi segundo carro. Lo que más valoro es la transparencia: sabes exactamente cuánto ganas y cuándo lo recibes. Si quieres profesionalizar tu carrera como modelo, TM es la mejor decisión.',
  },
  {
    id: 5,
    modelId: 2,
    tag: 'Elite Model',
    preview: 'De sueño a realidad',
    experience:
      'TM Studio me abrió las puertas al mundo del modeling profesional. El nivel de las instalaciones y el trato del equipo superan cualquier expectativa. Hoy puedo decir que vivir de lo que me apasiona es posible gracias a TM.',
  },
  {
    id: 6,
    modelId: 23,
    tag: 'Global Talent',
    preview: 'Más allá de las fronteras',
    experience:
      'Como modelo influencer, TM Studio me dio las herramientas para expandirme internacionalmente. La plataforma es sólida, los porcentajes son justos y el respaldo que dan es incomparable. Una decisión que cambió mi carrera.',
  },
  {
    id: 7,
    modelId: 11,
    tag: 'Studio Elite',
    preview: 'Profesionalismo y calidez',
    experience:
      'Lo que más destaco de TM Studio es el equilibrio entre seriedad profesional y un ambiente humano. Aquí no eres un número: te conocen, te escuchan y te apoyan para que des lo mejor. Totalmente recomendado.',
  },
  {
    id: 8,
    modelId: 18,
    tag: 'Rising Star',
    preview: 'Mi primer año en TM',
    experience:
      'En mi primer año ya alcancé metas que no imaginaba. Los pagos semanales me ayudaron a organizar mis finanzas y la capacitación continua me hizo crecer como modelo. TM Studio es mi segundo hogar.',
  },
];
